import { render, staticRenderFns } from "./XCard.vue?vue&type=template&id=4cab45bc&"
import script from "./XCard.vue?vue&type=script&lang=js&"
export * from "./XCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports